module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/en.json
// module id = 558
// module chunks = 0